import { forwardRef } from 'react';
import { IconType } from 'react-icons';
import { Button, ButtonProps } from '@heroui/button';
import classNames from 'classnames';

interface SquareButtonProps extends ButtonProps {
  icon?: IconType;
  spinIcon?: boolean;
  text?: string;
  subText?: string;
}

const SquareButton = forwardRef<HTMLButtonElement, SquareButtonProps>(
  function SquareButton({
    text,
    subText,
    spinIcon = false,
    icon: Icon,
    ...rest
  }, ref) {
    return (
      <Button
        ref={ref}
        className="px-3 min-w-14 h-14 sm:min-w-16 sm:h-16"
        isIconOnly={!!Icon}
        size="lg"
        variant="solid"
        {...rest}
      >
        <div>
          {Icon && <div className={classNames('text-foreground', { 'animate-spin': spinIcon })}><Icon size={22} /></div>}
          {text && (
            <div className="text-lg leading-6">
              {text}
            </div>
          )}
          {subText && (
            <div className="text-[0.6rem] leading-4 uppercase">{subText}</div>
          )}
        </div>
      </Button>
    );
  }
);

export default SquareButton;
